// API decimal strings stay exact, including values above Number.MAX_SAFE_INTEGER.
export function formatTransactionNaira(value) {
  const match = /^(\d+)(?:\.(\d{1,2}))?$/.exec(String(value ?? ''));
  if (!match) return 'Unavailable';
  const fraction = (match[2] || '').padEnd(2, '0');
  const whole = match[1].replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `₦${whole}${fraction === '00' ? '' : `.${fraction}`}`;
}
